import $ from 'jquery';

$('#jsDestinationCountry').on('click', function(){
  const url = window.location.href;
  const segments = url.replace(/\/$/, "").split("/");

  const destinationCountry = decodeURIComponent(segments[segments.length - 1]);

  dataLayer.push({
    event_name: "calling_abroad",
    event_label: destinationCountry,
    event: "fireEvent"
   });
})